import { render, staticRenderFns } from "./history.vue?vue&type=template&id=0bcb3e9e&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=0bcb3e9e&scoped=true&lang=css&"
import style1 from "./history.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb3e9e",
  null
  
)

export default component.exports